module.exports = __webpack_public_path__ + "static/media/Dark grey 13.08e09bb1.jpg";